import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HomeOne from './HomeOne'
import HomeTwo from './HomeTwo'
import About from './About'
import Service from './Service'
import ServiceDetails from './ServiceDetails'
import Faq from './Faq'
import Testimonial from './Testimonial'
import Team from './Team'
import TeamDetails from './TeamDetails'
import Portfolio from './Portfolio'
import PortfolioDetails from './PortfolioDetails'
import Pricing from './Pricing'
import Blog from './Blog'
import BlogDetails from './BlogDetails'
import Contact from './Contact'
import Error from './Error'


function RouterPage() {
  const rawPublicUrl = process.env.PUBLIC_URL;
  const basename = rawPublicUrl && rawPublicUrl !== '.' ? rawPublicUrl : '/';

  return (
    <div>
      <Router basename={basename}>
        {/* <LoadTop /> */}
        <Routes>
          <Route path="/" element={<HomeOne />}></Route>
          <Route path="/home-two" element={<HomeTwo />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/service" element={<Service />}></Route>
          <Route path="/service-details" element={<ServiceDetails />}></Route>
          <Route path="/service/:slug" element={<ServiceDetails />}></Route>
          <Route path="/faq" element={<Faq />}></Route>
          <Route path="/testimonial" element={<Testimonial />}></Route>
          <Route path="/team" element={<Team />}></Route>
          <Route path="/team-details" element={<TeamDetails />}></Route>
          <Route path="/portfolio" element={<Portfolio />}></Route>
          <Route path="/portfolio-details" element={<PortfolioDetails />}></Route>
          <Route path="/portfolio/:slug" element={<PortfolioDetails />}></Route>
          <Route path="/pricing" element={<Pricing />}></Route>
          <Route path="/blog" element={<Blog />}></Route>
          <Route path="/blog-details" element={<BlogDetails />} />
          <Route path="/blog/:slug" element={<BlogDetails />} />
          <Route path="/contact" element={<Contact />}></Route>
          <Route path="*" element={<Error />}></Route>
        </Routes>
      </Router>
    </div>
  )
}

export default RouterPage